import React from "react";
import {Card, Image, Space, Typography} from "antd"
import {FilePdfOutlined, FileZipOutlined} from "@ant-design/icons"
import MIME from "mime"
import {ASSET_BASE_URL} from "../../../../configs/AppConfig";
import {saveAs} from 'file-saver';

const {Text} = Typography

var uploadUrl = "https://kehilaapi.syn-assist.fr/v1/forms/upload"
if (process.env.NODE_ENV === "production") {
    uploadUrl = "https://api.kehila.syn-assist.fr/v1/forms/upload"
}

export default class UploadDataField extends React.Component {

    download(doc) {
        var xhr = new XMLHttpRequest();
        xhr.open("GET", ASSET_BASE_URL + "/" + doc.doc);
        xhr.responseType = "blob";

        xhr.onload = function () {
            saveAs(this.response, doc.name); // saveAs is a part of FileSaver.js
        };
        xhr.send();
    }

    renderDoc(doc) {

        if (!doc.doc) {
            doc.doc = doc.id
        }

        var mime = MIME.getType(doc.doc)
        var type = "ZIP"

        if (mime?.startsWith("image/")) {
            type = "IMAGE"
        } else if (mime === "application/pdf") {
            type = "PDF"
        }

        return (
            <Card bodyStyle={{padding: 10, width: 120, height: 150}}>
                <div style={{display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center"}}>
                    {type === "IMAGE" && (
                        <Image height={100} width={100} src={ASSET_BASE_URL + "/" + doc.doc}/>
                    )}
                    {(type === "PDF" || type === "ZIP") && (
                        <div style={{
                            height: 100,
                            width: 100,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center"
                        }}>
                            {type === "PDF" && <FilePdfOutlined style={{fontSize: 50}}/>}
                            {type === "ZIP" && <FileZipOutlined/>}
                        </div>
                    )}
                    <Text onClick={() => this.download(doc)} style={{cursor: "pointer", marginTop: 10}}
                          ellipsis={true}>{doc.name}</Text>
                </div>
            </Card>
        )
    }

    render() {
        const {edit, propertie, value, onChange, form} = this.props


        if (propertie.startsWith("[DOCUMENT]_")) {
            return this.renderDoc(value)
        }

        if (propertie.startsWith("[DOCUMENT_MULTI]_")) {
            return (
                <div style={{
                    display: "flex",
                    flexWrap: "nowrap",
                    width: "100%",
                    overflowX: "auto",
                    overflowY: "hidden",
                    padding: 10
                }}>
                    <Image.PreviewGroup>
                        <Space>
                            {value.map(doc => this.renderDoc(doc))}
                        </Space>
                    </Image.PreviewGroup>
                </div>

            )
        }


    }
}
